"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Options = void 0;
/**
 * Default options for Aveta.
 */
exports.Options = {
    separator: '.',
    lowercase: false,
    precision: 1,
    roundingMode: 'nearest',
    digits: 0,
    space: false,
    base: 1000,
    units: [
        '',
        'K',
        'M',
        'B',
        'T',
        'P',
        'E', // Quintillion
    ],
};
//# sourceMappingURL=options.js.map